import { useEffect, useState } from "react";
import { Loader2, X } from "lucide-react";
import { api, apiError } from "@/lib/api";

// Aperçu du contenu EXACT d'un email envoyé (admin). Le HTML est rendu dans une
// iframe sandboxée (aucun script exécuté) pour reproduire ce que voit le destinataire.
export function EmailPreview({ emailId, onClose }) {
  const [log, setLog] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!emailId) return undefined;
    setLog(null);
    setError("");
    api.get(`/admin/emails/${emailId}`)
      .then(({ data }) => setLog(data))
      .catch((e) => setError(apiError(e.response?.data?.detail) || e.message));
    const onKey = (e) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [emailId, onClose]);

  if (!emailId) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-3 sm:p-6" onClick={onClose} data-testid="email-preview-modal">
      <div className="flex h-full max-h-[92vh] w-full max-w-3xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between gap-3 border-b border-neutral-200 px-5 py-4">
          {log ? (
            <div className="min-w-0 text-sm">
              <p className="truncate text-base font-bold text-neutral-900" data-testid="email-preview-subject">{log.subject}</p>
              <p className="mt-1 truncate text-neutral-600">À : <strong data-testid="email-preview-to">{log.to}</strong></p>
              <p className="mt-0.5 text-xs text-neutral-500">
                {new Date(log.created_at).toLocaleString("fr-FR")} · {log.status === "failed" ? "Non envoyé" : "Envoyé"}
                {log.error ? ` — ${log.error}` : ""}
              </p>
            </div>
          ) : <span className="text-sm text-neutral-500">Chargement…</span>}
          <button onClick={onClose} data-testid="email-preview-close" className="shrink-0 rounded-lg p-1.5 text-neutral-500 hover:bg-neutral-100" aria-label="Fermer">
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="min-h-0 flex-1 bg-neutral-100">
          {error ? (
            <p className="p-6 text-sm text-red-600">{error}</p>
          ) : !log ? (
            <div className="grid h-full place-items-center"><Loader2 className="h-6 w-6 animate-spin text-brand" /></div>
          ) : log.html ? (
            <iframe title="Aperçu de l'email" sandbox="" srcDoc={log.html} className="h-full w-full border-0 bg-white" data-testid="email-preview-frame" />
          ) : (
            <p className="p-6 text-sm text-neutral-500">Contenu non disponible pour cet email.</p>
          )}
        </div>
      </div>
    </div>
  );
}
